<template>
  <div class="row">
    <div class="col-20">
      <title-block
        :title="$t('view-Settings.title')"
        :subtitle="$t('view-Settings.title.subtitle')"
        :text="$t('view-Settings.title.text')"
      />
      <div class="row">
        <div class="col-20 order-2 col-lg-6 order-lg-1">
          <div class="row buttons subroute-buttons">
            <router-link
              :to="{name: 'settings-password'}"
              class="col-20 std-wrapper subroute-button"
            >
              {{ $t('view-Settings.button.password-change') }}
            </router-link>
            <router-link
              :to="{name: 'settings-lang'}"
              class="col-20 std-wrapper subroute-button"
            >
              {{ $t('view-Settings.button.lang-change') }}
            </router-link>
            <router-link
              :to="{name: 'settings-email'}"
              class="col-20 std-wrapper subroute-button"
            >
              {{ $t('view-Settings.button.email-change') }}
            </router-link>
            <router-link
              :to="{name: 'settings-notifications'}"
              class="col-20 std-wrapper subroute-button"
            >
              {{ $t('view-Settings.button.notifications') }}
            </router-link>
            <router-link
              :to="{name: 'settings-account-delete'}"
              class="col-20 std-wrapper subroute-button"
            >
              {{ $t('view-Settings.button.account-delete') }}
            </router-link>
          </div>
        </div>
        <div class="col-20 order-1 col-lg-13 order-lg-2 offset-lg-1">
          <div class="row">
            <div class="col-20 std-wrapper p-4 pb-5">
              <transition
                name="fade"
                @before-leave="makeAbsolute"
              >
                <router-view />
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
</style>
